import Dropdown from '@admin/components/form/dropdown'
import PropTypes from 'prop-types'
import React from 'react'

class OverflowField extends React.Component {

  static propTypes = {
    defaultValue: PropTypes.any,
    value: PropTypes.any,
    website: PropTypes.object,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    overflow: null
  }

  _handleChange = _.debounce(this._handleChange.bind(this), 100, { trailing: true })
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    if(!this.state.overflow) return null
    return <Dropdown { ...this._getDropdown() } />
  }

  componentDidMount() {
    const defaultValue = this._getDefaultValue()
    this._handleSet(defaultValue)
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props
    const { overflow } = this.state
    if(!_.isEqual(overflow, prevState.overflow)) {
      this._handleChange()
    }
    if(!_.isEqual(value, prevProps.value)) {
      this._handleSet(value)
    }
  }

  _getDefaultValue() {
    const { defaultValue, value } = this.props
    return !_.isNil(value) ? value : !_.isNil(defaultValue) ? defaultValue : null
  }

  _getDropdown() {
    const { overflow } = this.state
    return {
      options: [
        { text: 't(Show)', value: 'show' },
        { text: 't(Hidden)', value: 'hidden' },
        { text: 't(Scroll Horizontally)', value: 'horizontal' },
        { text: 't(Scroll Vertically)', value: 'vertical' }
      ],
      value: overflow,
      onChange: this._handleUpdate
    }
  }

  _handleChange() {
    const { overflow } = this.state
    this.props.onChange(overflow !== 'show' ? overflow : null)
  }

  _handleSet(overflow) {
    this.setState({
      overflow: overflow || 'show'
    })
  }

  _handleUpdate(overflow) {
    this.setState({ overflow })
  }

}

export default OverflowField
